// Team Insights — Splits strings (prefix `ins.split.`)
const en = {
  "ins.split.unknownTrack": "Unknown track",
  "ins.split.status.pending": "Pending",
  "ins.split.status.accepted": "Accepted",
  "ins.split.status.active": "Active",
  "ins.split.status.rejected": "Rejected",
  "ins.split.status.cancelled": "Cancelled",
  "ins.split.flowTitle": "Revenue flow",
  "ins.split.flowDesc": "How each track's earnings are divided between you and your collaborators.",
  "ins.split.chooseTrack": "Choose a track",
  "ins.split.owner": "Owner",
  "ins.split.you": "you",
  "ins.split.yourEarned": "You earned from this track",
  "ins.split.share": "Share",
  "ins.split.legendAccepted": "Accepted share",
  "ins.split.legendPending": "Pending invitation",
  "ins.split.fullAnalytics": "See full analytics →",
};

const tr = {
  "ins.split.unknownTrack": "Bilinmeyen parça",
  "ins.split.status.pending": "Beklemede",
  "ins.split.status.accepted": "Kabul edildi",
  "ins.split.status.active": "Aktif",
  "ins.split.status.rejected": "Reddedildi",
  "ins.split.status.cancelled": "İptal edildi",
  "ins.split.flowTitle": "Gelir akışı",
  "ins.split.flowDesc": "Her parçanın kazancının sizinle iş birlikçileriniz arasında nasıl paylaşıldığı.",
  "ins.split.chooseTrack": "Parça seçin",
  "ins.split.owner": "Sahip",
  "ins.split.you": "siz",
  "ins.split.yourEarned": "Bu parçadan kazancınız",
  "ins.split.share": "Pay",
  "ins.split.legendAccepted": "Kabul edilmiş pay",
  "ins.split.legendPending": "Bekleyen davet",
  "ins.split.fullAnalytics": "Tüm analitiği görün →",
};

const es = {
  "ins.split.unknownTrack": "Pista desconocida",
  "ins.split.status.pending": "Pendiente",
  "ins.split.status.accepted": "Aceptado",
  "ins.split.status.active": "Activo",
  "ins.split.status.rejected": "Rechazado",
  "ins.split.status.cancelled": "Cancelado",
  "ins.split.flowTitle": "Flujo de ingresos",
  "ins.split.flowDesc": "Cómo se reparten las ganancias de cada pista entre tú y tus colaboradores.",
  "ins.split.chooseTrack": "Elige una pista",
  "ins.split.owner": "Propietario",
  "ins.split.you": "tú",
  "ins.split.yourEarned": "Lo que ganaste con esta pista",
  "ins.split.share": "Porcentaje",
  "ins.split.legendAccepted": "Porcentaje aceptado",
  "ins.split.legendPending": "Invitación pendiente",
  "ins.split.fullAnalytics": "Ver analíticas completas →",
};

export default { en, tr, es };
